// PublicShell — chrome for the pages that are also public (DECISIONS A9):
// /terms, /privacy, /about-app. Same header as the auth mockups
// (PhoneLogin / Login: wordmark left, one link right) so a signed-out visitor
// never sees the in-app nav or a Logout button. Provides ShellContext, which
// makes the legacy <Toolbar> those pages render step aside.
// `legacy` (default true) keeps the old Terms / Privacy pages' own look; pass
// legacy={false} for a redesigned page (e.g. About) so the ui.css reset applies.
import React, { useMemo } from 'react';
import { Link } from 'react-router-dom';
import { ShellContext } from './ShellContext';
import { useIsPhone } from '../components/util';

const signedIn = () => {
  try {
    return localStorage.getItem('authenticated') === 'true' && Boolean(localStorage.getItem('token'));
  } catch (_) {
    return false;
  }
};

export default function PublicShell({ children, legacy = true }) {
  const isPhone = useIsPhone();
  const ctx = useMemo(() => ({ inShell: true, isPhone, setPhoneHeader: null, resetPhoneHeader: null, risk: null, public: true }), [isPhone]);
  const authed = signedIn();
  return (
    <ShellContext.Provider value={ctx}>
      <div className="ui-root ui-shell">
        <header className="ui-pubhead">
          <div className="ui-header__in">
            <Link to="/" className="ui-wordmark">Cryptologics</Link>
            {authed ? <Link to="/profile/portfolio">Open the app</Link> : <Link to="/sign-in">Sign in</Link>}
          </div>
        </header>
        <div className={legacy ? 'ui-shell__main ui-legacy' : 'ui-shell__main'}>{children}</div>
      </div>
    </ShellContext.Provider>
  );
}
